module.exports = "images/franceinfo.c4236867.png";